import { createContext } from 'react';

import {
  TicketQueryResult,
  TicketQueryResults,
} from '@totem/components/ticketing/ticketing';
import { ObjectReference } from '@totem/types/common';

interface Context {
  loading: boolean;
  ticketData: TicketQueryResults;
  totalRecords: number;
  onTicketSelected?: (ticketId: string, ticket: TicketQueryResult) => void;
  selectedTickets: ObjectReference[];
  clearSelectedTickets: () => void;
  selectTicket: (ticketId: string, ticketNumber: string) => void;
  deselectTicket: (ticketId: string) => void;
  refetch: () => void;
}

export default createContext<Context>({
  loading: false,
  ticketData: null,
  totalRecords: 0,
  onTicketSelected: null,
  selectedTickets: [],
  clearSelectedTickets: () => {},
  selectTicket: () => {},
  deselectTicket: () => {},
  refetch: () => {},
});
